<wre-role-review-step *ngIf="!!role"
      [admins]="role.admins"
      [users]="role.users"
      [permissions]="role.permissions"
      [userCount]="usersCount"
      [adGroupCount]="adGroupCount"
      [servicePrincipleCount]="servicePrincipleCount"
      [isDetailsView]="true">
</wre-role-review-step>
